var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',_vm._l((_vm.buttons),function(btn){return _c('router-link',{key:btn.id,attrs:{"to":btn.link}},[_c('v-btn',{attrs:{"text":""}},[_vm._v(" "+_vm._s(btn.text)+" ")])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }